export default __webpack_public_path__ + "static/cinemaThoughtRecording-45715551a9c0e0e2408aa2fe3554f9df.svg";